var scope_0 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/49faf72f29ded5720c7e8de26128af24.js').default;
var scope_1 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5dbf8e02d2ab6fd562ec86b6ba0ef4d4.js').default;
var scope_2 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/687041a33f3411c7c405c28ab625134f.js').default;
var scope_3 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fbdeacebbd82e0f59737dbf4b960f1c6.js').default;
var scope_5 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fc75ee9fddf5073da3e1510467102a7a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    